<template>
  <div class="wrapper" style="width: 600px;border-radius: 6px;
  border: solid 2px #bbb; background-color: white; box-sizing: border-box; overflow: hidden;">
    <div class="box_section">
      <!-- 결제 UI -->
      <div id="payment-method"></div>
      <!-- 이용약관 UI -->
      <div id="agreement"></div>
      <!-- 쿠폰 체크박스 -->
      <!-- 결제하기 버튼 -->
      <UiButton v-if="getInputEnabled" style="margin-bottom: 20px; margin-left: 35%"
                :disabled="!getInputEnabled"
                @click="cancelPayment">취소</UiButton>
      <UiButton v-if="getInputEnabled" style="margin-left: 15px; "
                :disabled="!getInputEnabled"
                :primary="true"
                @click="requestPayment" >결제하기</UiButton>

    </div>
  </div>
</template>

<script>
import { loadPaymentWidget } from '@tosspayments/payment-widget-sdk'
import UiButton from '@/components/ui/UiButton'
import { confirmPayment } from '@/libs/confirmPayment'
import { getOrderId } from '@/libs/utils'
import { saveReportPayment } from '@/api/card'
import AppDialog from '@/components/ui/AppDialog'
import { create } from 'vue-modal-dialogs'

const openDialog = create(AppDialog)

export default {
  components: {
    UiButton
  },
  props: {
    price: {
      type: Number,
      default: 0
    },
    user: {
      default: {}
    },
    serviceType: {
      type: String,
      required: true
    },
    variantKey: {
      type: String,
      required: true
    },
    product: {
      type: String,
      required: true
    },
    pvCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      paymentWidget: null,
      paymentMethodWidget: null,
      clientKey: process.env.VUE_APP_TOSS_WIDGET_CLIENT,
      customerKey: this.user.userNum,
      amount: parseInt(this.price * 1.1),
      inputEnabled: false
    }
  },
  computed: {
    getInputEnabled () {
      return this.inputEnabled
    }
  },
  methods: {
    cancelPayment () {
      this.$emit('cancelTossPayment')
    },
    async requestPayment () {
      const confpayment = await confirmPayment
      try {
        if (this.paymentWidget) {
          let orderName = ''
          if (this.product === 'prefix') {
            orderName = 'CX Report (Prefix) 구매'
          } else if (this.product === 'segment') {
            orderName = 'CX Report (segment) 구매'
          } else if (this.product === 'indepth') {
            orderName = 'CX Report (In-depth) 구매'
          } else if (this.product === 'compare') {
            orderName = 'CX Report (기간 비교) 구매'
          }
          await this.paymentWidget.requestPayment({
            orderId: getOrderId(this.user.userNum),
            orderName: orderName,
            customerName: this.user.userName,
            customerEmail: this.user.userId,
            customerMobilePhone: this.user.phoneNumber
          }).then(resp => {
            if (resp.orderId && resp.amount && resp.paymentKey) {
              const requestData = {
                orderId: resp.orderId,
                amount: resp.amount,
                paymentKey: resp.paymentKey
              }
              confpayment(requestData).then(result => {
                if (result.code && result.message) {
                  this.$emit('cancelTossPayment')
                  openDialog({
                    dialogType: 'report.paymentFailed',
                    ok: this.$t('common.confirm'),
                    optionMsg: result.message
                  })
                } else {
                  const params = {
                    variantKey: this.variantKey,
                    serviceType: this.serviceType,
                    price: this.amount,
                    result: result,
                    approved: true
                  }

                  saveReportPayment(params).then(resp => {
                    if (resp.approval) {
                      this.$emit('successTossPayment', { variantKey: this.variantKey, paymentId: resp._id })
                    } else {
                      this.$emit('cancelTossPayment')
                    }
                  })
                }
              })
            }
          })
        }
      } catch (error) {
        // 에러 처리하기
        console.error(error)
      }
    },
    async updateAmount () {
      this.paymentMethodWidget.updateAmount(this.amount)
    }
  },
  async mounted () {
    this.paymentWidget = await loadPaymentWidget(this.clientKey, this.user.userNum)
    this.paymentMethodWidget = this.paymentWidget.renderPaymentMethods('#payment-method', { value: this.amount }, { variantKey: this.variantKey })
    this.paymentWidget.renderAgreement('#agreement', { variantKey: 'AGREEMENT' })

    this.paymentMethodWidget.on('ready', () => {
      this.inputEnabled = true
    })
  }
}
</script>
